exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CarouselVcDemo[data-v-225acfdb]{width:100%}.CarouselVcDemo .demoItem[data-v-225acfdb]{margin:10px 0 20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.CarouselVcDemo .demoItem .demoLabel[data-v-225acfdb]{margin:10px}.CarouselVcDemo p[data-v-225acfdb]{color:#066}.CarouselVcDemo .demoText[data-v-225acfdb]{margin:15px 10px 5px}", ""]);

// exports
